<template>
  <div
    class="elem-select custom-select"
    :class="[
      { 'inline-input-disabled': trSelectValue.block === true },
      { 'inline-input-correct': trSelectValue.inputStatus === 'correct' },
      { 'inline-input-wrong': trSelectValue.inputStatus === 'incorrect' },
      { 'inline-input-text-aling-center': elementTextAlign === 'center' },
      { 'inline-input-text-aling-left': elementTextAlign === 'left' },
      { 'inline-input-text-aling-right': elementTextAlign === 'right' },
    ]"
    :tabindex="tabindex"
    @blur="openFlag = false"
    :style="getTrSelectStyle(config)"
  >
    <div class="selected-container" :style="{ width: this.inputWidth + 'px' }">
      <div
        class="selected"
        :style="{ 'font-size': katexsize + 'px' }"
        :class="[{ open: openFlag }]"
        @click="open()"
        v-katex="removeUnnecessarySlash(selectVal)"
      ></div>
      <div class="selected disable-element" v-if="trSelectValue.block === true"></div>
    </div>
    <div class="items" :class="{ selectHide: !openFlag }">
      <div
        :style="{ 'font-size': katexsize + 'px' }"
        v-for="(option, i) of lmOptions"
        :key="i"
        @click="changeValue(option)"
        v-katex="removeUnnecessarySlash(option.val)"
      ></div>
    </div>
  </div>
</template>

<script>
import * as utils from '../../Utils/inputUtils';
import _ from 'lodash';
/**
 * @vue-prop  {Number} katexSize rozmiar czcionki dla elementow w selectcie
 * @vue-prop  {null} config pobranie konfigu z configu
 * @vue-prop  {array} options tablica elementow ktore znajduja sie w selectcie
 * @vue-prop  {object} obiekt pojedynczej opcji dla selecta, Parametry: correct- boolean(czy odpowiedz jest poprawna);val-string(tresc pojedynczej opcji w selectcie)
 * @vue-prop  {Number} tabindex index tablicy elementow dla select
 * @vue-prop  {null} inputWidth szerokosc inputa
 * @vue-prop  {null} inputHeight wysokosc inputa
 * @vue-prop  {object} maxLength maksymalna ilosc znakow w inpucie
 */
export default {
  props: {
    katexsize: {
      type: Number,
      default: function () {
        return 28;
      },
    },
    config: {
      type: null,
      default: function () {
        return {};
      },
    },
    options: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
    trSelectValue: {
      type: Object,
      default: function () {
        return { correct: undefined, val: '', block: false, inputStatus: null };
      },
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    //Style do Selecta z TrSelect bo Tomek strasznie wymagajacy
    inputWidth: {
      type: null,
      default: '',
    },
    inputHeight: {
      type: null,
      default: '',
    },
    maxLength: {
      type: null,
      default: 255,
    },
    inputFontSize: {
      type: Object,
      default: function () {
        return {};
      },
    },
    //KONIEC STYLI TOMKOWYCH
  },
  data() {
    return {
      lmOptions: {},
      openFlag: false,
      text: '',
    };
  },
  mounted() {
    this.lmOptions = this.options.map((item) => {
      let trValue = _.defaults({}, _.omit(item, 'text'), {
        correct: undefined,
        val: '',
        block: false,
        inputStatus: null,
      });
      trValue.val = item.text;
      return _.assign({}, trValue, { val: item.text });
    });
  },
  methods: {
    changeValue(option) {
      console.log('option', option);
      this.selectVal = option.val;
      this.openFlag = false;
      this.$emit('change', option);
    },
    emitNewValue(value) {
      // console.log( 'value', value );
      this.$emit('change', value);
    },
    open() {
      this.openFlag = !this.openFlag;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    getTrSelectStyle(item) {
      return _.merge({}, this.getCustomStyle(item), {
        top: this.elementTopPosition,
        left: this.elementLeftPosition,
        width: this.elementWidth,
        height: this.elementHeight + ' !important',
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    changeText(val) {
      this.selectVal = `\\textcolor{red}${val}}`;
    },
    /** Function added only for compatibility with hack in textBlock type components */
    removeUnnecessarySlash(string) {
      const search = '\\\\';
      const replaceWith = '\\';
      const result = string.split(search).join(replaceWith);
      return result;
      // return _.replace(string, '\\\\', '\\');
    },
  },
  computed: {
    selectVal: {
      get() {
        return this.trSelectValue.val;
      },
      set(newValue) {
        if (!this.trSelectValue.block) {
          console.log('newValue', newValue);
          this.trSelectValue.val = newValue;
        }
      },
    },
    elementTopPosition() {
      return this.config && this.config.pos
        ? utils.elementTopPosition(this.config.pos.y || 0, this.offsetVertical)
        : undefined;
    },
    elementLeftPosition() {
      return this.config && this.config.pos
        ? utils.elementLeftPosition(this.config.pos.x || 0, this.offsetHorizontal)
        : undefined;
    },
    elementWidth() {
      return utils.elementWidth(this.inputWidth);
    },
    elementHeight() {
      return utils.elementHeight(this.inputHeight);
    },
    elementTextAlign() {
      let align = 'center';
      if (this.config && this.config.align) {
        align = this.config.align;
        z - index;
      }
      return align;
    },
  },
  watch: {
    'trSelectValue.inputStatus': function (val, oldVal) {
      if (val === 'correct') {
        this.trSelectValue.val = `\\textcolor{#575c61}{${this.trSelectValue.val}}`;
      } else if (val === 'incorrect') {
        this.trSelectValue.val = `\\textcolor{red}{${this.trSelectValue.val}}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$inlineInputwrongColor: rgb(196, 29, 29);
$inputTextColor: rgb(255, 0, 0);
$inputTextBackgroundColor: rgb(255, 255, 255);
$inputTextDisabled: rgb(235, 235, 235);
$input3DShadow: rgb(179, 179, 179);
$selectTextDisableColor: #575c61;
.elem-select {
  position: relative;
  text-align: left;
  background-color: white;
  outline: none;
  /* height: 47px; */
  display: inline-block;
  /* width: 100%; */
  /* height: calc(1.5em + 0.75rem + 2px); */
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 38px !important;
  font-weight: 400;
  /* line-height: 1.5; */
  vertical-align: middle;
  /* line-height: 47px; */
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-size: 17px 17px;
  -webkit-appearance: none;
}
.inline-input {
  display: inline-flex;
  color: $inputTextColor !important;
  background-color: $inputTextBackgroundColor;
  // box-shadow: inset 0 0 10px 0 $input3DShadow !important;
  justify-content: center;
  align-items: center;
  text-align: center;
  vertical-align: baseline;
  &:focus {
    color: $inputTextColor;
    outline: none;
  }
}
.inline-input-wrong {
  background-color: rgba($inlineInputwrongColor, 0.1) !important;
  color: $inlineInputwrongColor !important;
}
.inline-input-disabled {
  pointer-events: none;
  color: $selectTextDisableColor;
  background-color: rgb(235, 235, 235);
}
.elem-select .selected {
  background-color: rgba(0, 0, 0, 0);
  border-radius: 6px;
  height: 70px;
  // border: 1px solid #666666;
  color: #000;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}
.inline-input-disabled {
  user-select: none;
  background-color: $inputTextDisabled;
}
.inline-input-correct {
  color: $inputTextColor;
  // box-shadow: inset 0 0 10px 0 $firstIconColor !important;
  background-color: rgba($firstIconColor, 0.6) !important;
}

.inline-input-text-aling-center {
  text-align: center;
}
.inline-input-text-aling-left {
  text-align: left;
}
.inline-input-text-aling-right {
  text-align: right;
}

.elem-select .items {
  color: #000;

  overflow: hidden;

  position: absolute;
  background-color: #fff;
  left: 0;
  right: 0;
  z-index: 1;
}

.elem-select .items div {
  color: #000;
  padding-left: 1em;
  padding-top: 10px;
  cursor: pointer;
  user-select: none;
}

.elem-select .items div:hover {
  background-color: #3e98f9;
  color: white;
}
.selected-container {
  width: 100%;
  height: 100%;
  align-items: center;
  display: flex;
  .selected {
    height: 100%;
    width: 100%;

    align-items: center;
    display: flex;
  }
  .disable-element {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.35);
  }
}
.selectHide {
  display: none;
}
</style>
